export class UserFormData {
  password: string;
  email: string;
}
